import { useCallback, useEffect, useState } from "react";

const KEY = "lerma_premium";
const EXP = "lerma_premium_expira";
const HOURS = 12;

function readPremium() {
  if (localStorage.getItem(KEY) === "true") {
    const exp = parseInt(localStorage.getItem(EXP) || "0", 10);
    if (Date.now() < exp) return true;
    localStorage.removeItem(KEY);
    localStorage.removeItem(EXP);
  }
  return false;
}

export function usePremium() {
  const [premium, setPremium] = useState(readPremium());
  const [expiresAt, setExpiresAt] = useState(parseInt(localStorage.getItem(EXP) || "0", 10));

  const activate = useCallback(() => {
    const exp = Date.now() + HOURS * 60 * 60 * 1000;
    localStorage.setItem(KEY, "true");
    localStorage.setItem(EXP, exp.toString());
    setExpiresAt(exp);
    setPremium(true);
  }, []);

  useEffect(() => {
    const t = setInterval(() => setPremium(readPremium()), 60000);
    return () => clearInterval(t);
  }, []);

  return { premium, activate, expiresAt };
}
